import React from "react"
import autobind from "class-autobind"
import strings from "../../../localization/strings"
import { Dialog, FlatButton, TextField, Divider, Toggle } from "material-ui"
import AccountStore from "../../../stores/AccountStore"
import { SelectField, MenuItem } from "material-ui"
import { IScheduleTemplate, ISchedulePatternTemplate, IScheduleDocument, IScheduleShift, IClientDocument, IJobDocument } from "../../../models"
import DayTimelineBar from "../../../components/schedule/DayTimelineBar"
import * as utils from "../../../helpers/utils"
import * as hierarchyHelper from "../../../helpers/hierarchyHelper"
import _ from "lodash"
import CreateMultiplePositionShift from "./CreateMultiplePositionShift"
import CreateSimplePositionShift from "./CreateSimplePositionShift"
import * as scheduleHelper from "../../../helpers/scheduleHelper"
import AppStateStore from "../../../stores/AppStateStore"
import * as userHelper from "../../../helpers/userHelper"
import ShiftSelectDays from "../common/ShiftSelectDays"
import * as timeHelper from "../../../helpers/timeHelper"

interface IProps {
    selectedDay: number
    schedule: IScheduleDocument | IScheduleTemplate
    handleClose(): void
    handleAddPatternTemplates(patternTemplates: ISchedulePatternTemplate[], days: number[]): void

    scheduleJob?: IJobDocument
    scheduleClient?: IClientDocument

    // Schedule -> ScheduleTemplate case.    
    isScheduleTemplate?: boolean
}

interface IState {
    selectedShiftOrPattern: IScheduleShift | ISchedulePatternTemplate | "CreateMultiplePositionShift" | "CreateSimplePositionShift"
    showTimelineBar: boolean
    quantity: number
    errorQuantity: boolean
    newMultiplePositionShift: ISchedulePatternTemplate
    newSimplePositionShift: IScheduleShift
    overrideHierarchy: boolean
}

export default class AddShiftsDialog extends React.Component<IProps, IState> {
    private CreateMultiplePositionShift
    private selectedDays: number[]
    constructor(props: IProps) {
        super(props)
        this.state = {
            selectedShiftOrPattern: null,
            showTimelineBar: true,
            quantity: 1,
            errorQuantity: false,
            newMultiplePositionShift: null,
            newSimplePositionShift: null,
            overrideHierarchy: false
        }
        autobind(this)
        this.selectedDays = [props.selectedDay]
    }

    handleSave() {
        const patternTemplates = []
        let payload: ISchedulePatternTemplate

        if (this.state.selectedShiftOrPattern === "CreateMultiplePositionShift") {
            payload = this.state.newMultiplePositionShift
        }
        else if (this.state.selectedShiftOrPattern === "CreateSimplePositionShift") {
            payload = {
                Id: utils.guid(),
                Name: this.state.newSimplePositionShift.Name,
                HierarchyId: this.state.newSimplePositionShift.HierarchyId,
                ShiftTemplates: [this.state.newSimplePositionShift]
            }
        }
        else if (this.state.selectedShiftOrPattern.hasOwnProperty("AssignedUserName")) {
            // pattern templated selected
            const patternTemplate = this.state.selectedShiftOrPattern as ISchedulePatternTemplate
            payload = _.cloneDeep(patternTemplate)
            if (this.state.overrideHierarchy) {
                payload = scheduleHelper.overridePatternTemplateHierarchy(payload, this.props.schedule.HierarchyId, this.props.scheduleJob, this.props.scheduleClient)
            }
        }
        else {
            // shift template selected
            let shift = _.cloneDeep(this.state.selectedShiftOrPattern) as IScheduleShift
            if (this.state.overrideHierarchy) {
                shift = scheduleHelper.overrideShiftTemplateHierarchy(shift, this.props.schedule.HierarchyId, this.props.scheduleJob, this.props.scheduleClient)
            }
            payload = {
                Id: utils.guid(),
                Name: shift.Name,
                HierarchyId: shift.HierarchyId,
                ShiftTemplates: [shift]
            }
        }

        (this.props.isScheduleTemplate ? [this.props.selectedDay] : this.selectedDays).forEach(selectedDay => {
            const patternTemplate = scheduleHelper.updatePatternTemplateTimeForDay(timeHelper.keepConvertUTCToLocal(this.props.schedule.StartDate), selectedDay, payload)
            for (let i = 0; i < this.state.quantity; i++) {
                const clonePatternTemplate = _.cloneDeep(patternTemplate)
                if (!this.props.isScheduleTemplate) {
                    clonePatternTemplate.Id = utils.guid()
                    clonePatternTemplate.ShiftTemplates.forEach(j => {
                        j.Id = utils.guid()
                    })
                }
                patternTemplates.push(clonePatternTemplate)
            }
        })

        this.props.handleAddPatternTemplates(patternTemplates, this.selectedDays)
    }

    getDayTimelineBarData(): IScheduleShift[] {
        if (!this.state.selectedShiftOrPattern) return []
        if (this.state.selectedShiftOrPattern === "CreateMultiplePositionShift") {
            return this.CreateMultiplePositionShift ? this.CreateMultiplePositionShift.state.shiftTemplates : []
        }
        else if (this.state.selectedShiftOrPattern === "CreateSimplePositionShift") {
            return this.state.newSimplePositionShift ? [this.state.newSimplePositionShift] : []
        }
        else if (this.state.selectedShiftOrPattern.hasOwnProperty("AssignedUserName")) {
            const payload = this.state.selectedShiftOrPattern as ISchedulePatternTemplate
            return payload.ShiftTemplates
        }
        else {
            const payload = this.state.selectedShiftOrPattern as IScheduleShift
            return [payload]
        }
    }

    initDialogData() {
        this.setState({
            newMultiplePositionShift: null,
            newSimplePositionShift: null
        }, () => this.initShowTimelineBar())
    }

    initShowTimelineBar() {
        this.setState({ showTimelineBar: false }, () => this.setState({ showTimelineBar: true }))
    }

    render() {
        return (
            <Dialog
                id="AddShiftDialog"
                open={true}
                title={strings.Add_Shift}
                titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
                actions={[
                    <span style={{ fontSize: 19, marginRight: 100, color: "#F57C00" }}>
                        {this.state.quantity > 200 && strings.formatString(strings.The_Qty_must_be_less_than_or_equal_to_x, 200)}
                    </span>,
                    <FlatButton
                        data-intercom-target={"AddShifts-Btn-CloseAddShiftDialog"}
                        label={strings.CANCEL}
                        secondary={true}
                        onClick={this.props.handleClose}
                    />,
                    <FlatButton
                        data-intercom-target={"AddShifts-Btn-SaveShift"}
                        label={strings.SAVE}
                        primary={true}
                        onClick={this.handleSave}
                        disabled={
                            !this.state.selectedShiftOrPattern ||
                            this.state.errorQuantity ||
                            (this.state.selectedShiftOrPattern === "CreateMultiplePositionShift" && !this.state.newMultiplePositionShift ? true : false) ||
                            (this.state.selectedShiftOrPattern === "CreateSimplePositionShift" && !this.state.newSimplePositionShift ? true : false)
                        }
                    />
                ]}
            >
                <hr />
                <div style={{ paddingRight: 20, paddingLeft: 20 }}>
                    <Toggle
                        data-intercom-target={"Shift-AddShift-Toggle-OverrideHierarchy"}
                        label={strings.Override_hierarchy}
                        toggled={this.state.overrideHierarchy}
                        style={{ width: 225, marginTop: 25 }}
                        onToggle={(e, value) => this.setState({ overrideHierarchy: value, selectedShiftOrPattern: null })}
                    />
                    <div style={{ display: "flex", marginTop: -10, justifyContent: "space-between" }}>
                        <div style={{ display: "flex" }}>
                            <div>
                                <SelectField
                                    data-intercom-target={"Shift-AddShift-Select-Shift"}
                                    floatingLabelText={this.props.isScheduleTemplate ?
                                        AppStateStore.hideSchedulePatternTemplate ? strings.Shift_Template : strings.Shift_or_Pattern_Template :
                                        strings.Shift
                                    }
                                    value={this.state.selectedShiftOrPattern}
                                    onChange={(e, index, value) => this.setState({ selectedShiftOrPattern: value }, () => this.initDialogData())}
                                    style={{ width: 300 }}
                                >
                                    {!this.props.isScheduleTemplate && [
                                        <MenuItem key="CreateSimplePositionShift" value={"CreateSimplePositionShift"} primaryText={AppStateStore.hideSchedulePatternTemplate ? strings.Create_new_shift : strings.Create_simple_position_shift} />,
                                        !AppStateStore.hideSchedulePatternTemplate &&
                                        <MenuItem key="CreateMultiplePositionShift" value={"CreateMultiplePositionShift"} primaryText={strings.Create_multiple_position_shift} />,
                                        <Divider key="divider" />
                                    ]}
                                    {utils.sortAlphabetical(
                                        AccountStore.getCurrentAccount().ScheduleData.ShiftTemplates
                                            .filter(st => !st.Deleted &&
                                                (this.state.overrideHierarchy ?
                                                    userHelper.getSupervisorAccessHierarchyIds().includes(st.HierarchyId) :
                                                    this.props.scheduleClient ?
                                                        this.props.scheduleClient.Id === st.ClientId :
                                                        this.props.scheduleJob ?
                                                            this.props.scheduleJob.Id === st.JobId :
                                                            hierarchyHelper.getHierarchyIdsForShowAllChildHierarchyData(true, this.props.schedule.HierarchyId).includes(st.HierarchyId)
                                                )
                                            ),
                                        "Name")
                                        .map((shift) =>
                                            <MenuItem value={shift} primaryText={`${strings.Shift}: ${shift.Name}`} key={shift.Id} />
                                        )}
                                    {!AppStateStore.hideSchedulePatternTemplate &&
                                        utils.sortAlphabetical(
                                            AccountStore.getCurrentAccount().ScheduleData.PatternTemplates
                                                .filter(pt => !pt.Deleted &&
                                                    (this.state.overrideHierarchy ?
                                                        userHelper.getSupervisorAccessHierarchyIds().includes(pt.HierarchyId) :
                                                        pt.ShiftTemplates.length ?
                                                            this.props.scheduleClient ?
                                                                this.props.scheduleClient.Id === pt.ShiftTemplates[0].ClientId :
                                                                this.props.scheduleJob ?
                                                                    this.props.scheduleJob.Id === pt.ShiftTemplates[0].JobId :
                                                                    hierarchyHelper.getHierarchyIdsForShowAllChildHierarchyData(true, this.props.schedule.HierarchyId).includes(pt.HierarchyId) :
                                                            false
                                                    )
                                                ),
                                            "Name")
                                            .map((patternTempalte) =>
                                                <MenuItem value={patternTempalte} primaryText={`${strings.Pattern}: ${patternTempalte.Name}`} key={patternTempalte.Id} />
                                            )}
                                </SelectField>
                            </div>
                            <div style={{ marginLeft: 20 }}>
                                <TextField
                                    data-intercom-target={"Shift-AddShift-Entry-Qunatity"}
                                    floatingLabelText={strings.Qty}
                                    type="number"
                                    value={this.state.quantity}
                                    onChange={(e, value) => this.setState({ quantity: value, errorQuantity: value <= 0 || value > 200 })}
                                    style={{ width: 50 }}
                                />
                            </div>
                        </div>
                    </div>
                    <div style={{ display: "flex" }}>
                        <div style={{ marginTop: 12 }}>
                            {this.state.selectedShiftOrPattern === "CreateMultiplePositionShift" &&
                                <CreateMultiplePositionShift
                                    ref={(elem) => this.CreateMultiplePositionShift = elem}
                                    hierarchyId={this.props.schedule.HierarchyId}
                                    handleSave={(newMultiplePositionShift) => this.setState({ newMultiplePositionShift }, () => this.initShowTimelineBar())}
                                    scheduleJob={this.props.scheduleJob}
                                    scheduleClient={this.props.scheduleClient}
                                />
                            }
                            {this.state.selectedShiftOrPattern === "CreateSimplePositionShift" &&
                                <CreateSimplePositionShift
                                    shiftTemplate={this.state.newSimplePositionShift}
                                    hierarchyId={this.props.schedule.HierarchyId}
                                    handleSave={(newSimplePositionShift) => this.setState({ newSimplePositionShift }, () => this.initShowTimelineBar())}
                                    scheduleJob={this.props.scheduleJob}
                                    scheduleClient={this.props.scheduleClient}
                                />
                            }
                        </div>
                    </div>
                    <div style={{ marginTop: 20, marginBottom: 15 }}>
                        <ShiftSelectDays
                            excludeSelectedDay={false}
                            isScheduleTemplate={this.props.isScheduleTemplate}
                            scheduleStartDate={timeHelper.keepConvertUTCToLocal(this.props.schedule.StartDate)}
                            dayLength={scheduleHelper.getDayLengthFromStartAndEndTime(this.props.schedule.StartDate, this.props.schedule.EndDate)}
                            selectedDay={this.props.selectedDay}
                            handleSelectDays={selectedDays => this.selectedDays = selectedDays}
                        />
                    </div>
                    <div style={{ height: 110 }}>
                        {this.state.showTimelineBar &&
                            <DayTimelineBar
                                shiftTemplates={this.getDayTimelineBarData()}
                                totalWidth={888}
                            />
                        }
                    </div>
                </div>
            </Dialog>
        )
    }
}